export const addInterceptor = [{
  name: 'method',
  type: [String, Object],
  required: true
}]
export const removeInterceptor = addInterceptor
